// Compiled at 2026-10-07T06:21:14.844Z
// Compiled at 2026-10-07T06:21:14.844Z
// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import { Sys } from "@lg/ng-shared";
import * as Toolbox from "./Toolbox/Toolbox.js";
import * as System from "./System/System.js";
import * as Common from "./Common/Common.js";

export { Toolbox, System, Common };
Object.assign(globalThis, { Sys, Toolbox, System, Common, This: Toolbox })
